// Package Imports
import React, { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';
import PrivateRouteConst from 'core/common/privateRouteConstant';

// Lazy-loaded Component
const BulkUser = lazy(() => import('pages/users/bulkUser/bulkUser'));

const BulkUserRoute = (
  <Route
    path={routeName.bulkUser}
    element={
      <PrivateRoute name={PrivateRouteConst.USER_BULK_UPLOAD}>
        <Suspense fallback={<Loading />}>
          <BulkUser />
        </Suspense>
      </PrivateRoute>
    }
  />
);

export default BulkUserRoute;
